import { useState, useEffect } from "react";
import sanityClient from "../client.js";

import Details from "../components/Details.js";
import Carousel from "../components/Carousel.js";
import Info from "../components/Info.js";
import PrevNext from "../components/PrevNext.js";
import Timeline from "../components/Timeline.js";
import Screensaver from "../components/Screensaver.js";

function Home(props) {
  const { isMobile } = props;
  const [pageData, setPageData] = useState(null);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [totalSlides, setTotalSlides] = useState(0);

  const [slides, setSlides] = useState();
  const [titles, setTitles] = useState({});
  const [clients, setClients] = useState({});
  const [years, setYears] = useState({});
  const [roles, setRoles] = useState({});

  const [infoOpen, setInfoOpen] = useState(false);

  
  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "settings"][0]{ 
        title,
        carousel[]->{...},
        about,
        emailAddress,
        socials,
        screensaver[]
      }`
      )
      .then((data) => {

        setPageData(data);

        const titlesObj = {};
        const clientsObj = {};
        const yearsObj = {};
        const rolesObj = {};

        data.carousel.forEach((project, index) => {
          titlesObj[index] = project.title;
          yearsObj[index] = project.year;
          project.client? (clientsObj[index] = project.client): (clientsObj[index] = 'N/A')
          project.role? (rolesObj[index] = project.role): (rolesObj[index] = 'N/A')
        });

        setSlides(data.carousel);
        setTitles(titlesObj);
        setClients(clientsObj);
        setYears(yearsObj);
        setRoles(rolesObj);
        setTotalSlides(Object.getOwnPropertyNames(titlesObj).length);

      })
      .catch();
  }, []);

  if (pageData) {
    return (
      <main>
        <Info {...{
          pageData,
          infoOpen,
          setInfoOpen
        }} />
        <Timeline
          {...{
            currentIndex,
            setCurrentIndex,
            slides,
            totalSlides,
            infoOpen,
          }}
        />
        <Carousel
          {...{
            currentIndex,
            slides,
            isMobile,
          }}
        />
        <PrevNext
          {...{
            currentIndex,
            setCurrentIndex,
            totalSlides,
          }}
        />
        <Details
          {...{
            currentIndex,
            totalSlides,
            titles,
            clients,
            years,
            roles,
          }}
        />
        <Screensaver {...{pageData}} />
      </main>
    );
  }
}

export default Home;
